import React from 'react';

import {
  Box,
  Flex,
  useMediaQuery,
} from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import {
  ImageComponent,
  PageWrapper,
  SectionTitle,
} from '../../../components';
import {
  HOW_WE_WORK_IMG,
  HOW_WE_WORK_IMG_MOBILE,
} from '../../../constants/ImagePaths';

const HowWeWorkSection = () => {
  const { t } = useTranslation();
  const [isMobile] = useMediaQuery(
    '(max-width: 767px)'
  );

  return (
    <PageWrapper>
      <Box
        paddingTop={{
          base: '30px',
          md: '50px',
        }}
      />

      <SectionTitle
        title={t('homepage.howWeWork.title')}
        description={t(
          'homepage.howWeWork.description'
        )}
      />

      <Flex
        width="100%"
        margin={0}
        padding={0}
        alignItems="flex-start"
      >
        <ImageComponent
          src={
            isMobile
              ? HOW_WE_WORK_IMG_MOBILE
              : HOW_WE_WORK_IMG
          }
          altMessage="How we work"
          others={{
            display: 'block',
            width: '100%',
            height: 'auto',
            objectFit: 'contain',
            margin: 0,
            padding: 0,
          }}
        />
      </Flex>
    </PageWrapper>
  );
};

export default HowWeWorkSection;